var map = {
	"./404.svg": "49be",
	"./CONFIRMORDER-processed.svg": "e30b",
	"./CONFIRMORDER-processing.svg": "267d",
	"./CONFIRMORDER.svg": "e30b3",
	"./DELIVERGOODS-processed.svg": "d5db",
	"./DELIVERGOODS-processing.svg": "27a9",
	"./DELIVERGOODS.svg": "69a2",
	"./ENDORDER-processed.svg": "a4a2",
	"./ENDORDER-processing.svg": "ac69",
	"./ENDORDER.svg": "5c66",
	"./Excel.svg": "a5c9",
	"./Nokown.svg": "9f3f",
	"./OPPOSE-processed.svg": "57ff",
	"./OPPOSE-processing.svg": "346a",
	"./OPPOSE.svg": "2956",
	"./Pdf.svg": "9eff",
	"./SAVEORDER-processed.svg": "bcc4",
	"./SAVEORDER-processing.svg": "44ce",
	"./SAVEORDER.svg": "c6b8",
	"./SUBMITORDER-processed.svg": "a1b2",
	"./SUBMITORDER-processing.svg": "c522",
	"./SUBMITORDER.svg": "764a",
	"./TAKEDELIVERY-processed.svg": "dbac",
	"./TAKEDELIVERY-processing.svg": "5f76",
	"./TAKEDELIVERY.svg": "2ca7",
	"./Top1.svg": "895e",
	"./Top2.svg": "a2fb",
	"./Top3.svg": "9a24",
	"./Top4.svg": "a4bf",
	"./Top5.svg": "9879",
	"./Top6.svg": "279e",
	"./Txt.svg": "b6cf",
	"./Word.svg": "85c5",
	"./ad1.svg": "5825",
	"./ad10.svg": "0b2b",
	"./ad2.svg": "55db",
	"./ad3.svg": "324a",
	"./add.svg": "5110",
	"./back.svg": "972be",
	"./close.svg": "864a",
	"./daohangqiehuan.svg": "003c",
	"./delete.svg": "a3dd",
	"./dinghuo-bianji-hover.svg": "d48b",
	"./dinghuo-bianji.svg": "b45c",
	"./dinghuo-shanchu-hover.svg": "6695",
	"./dinghuo-shanchu.svg": "bc71",
	"./dinghuo-shangjia.svg": "cf24",
	"./dinghuo.svg": "7478",
	"./duigou.svg": "89e3",
	"./edit.svg": "2fb0",
	"./filter.svg": "3663",
	"./fukuan.svg": "2ed3",
	"./gerenxinxi.svg": "8a58",
	"./help.svg": "86c0",
	"./jian.svg": "9f41",
	"./jiqiren.svg": "e0b6",
	"./left.svg": "d6aa",
	"./line.svg": "a6d9",
	"./loucengjiqiren.svg": "2948",
	"./message.svg": "15e8",
	"./mobile.svg": "a91f",
	"./morentouxiang.svg": "c63b",
	"./nodata.svg": "43282",
	"./order-confirmation-add.svg": "7195",
	"./order-confirmation-plus.svg": "55a4",
	"./order.svg": "81a4",
	"./orderno.svg": "c3a1",
	"./pc.svg": "083f",
	"./phone.svg": "b470",
	"./presale.svg": "2437",
	"./qiyexinxi-hong.svg": "2bce",
	"./qiyexinxi-hui.svg": "f235",
	"./qq.svg": "39e1",
	"./quanping.svg": "b48e",
	"./receive.svg": "7239",
	"./reject.svg": "eb74",
	"./return-form.svg": "7395",
	"./rexiandianhua.svg": "c115",
	"./right.svg": "6ffa",
	"./shouqiquanping.svg": "95f5",
	"./switch-agent.svg": "7c40",
	"./switch-org.svg": "4196",
	"./switchIdentify.svg": "553f",
	"./switchTenant.svg": "7510",
	"./telegram.svg": "fd92",
	"./tuihuo.svg": "b7d4",
	"./tuikuan.svg": "170d",
	"./wechat.svg": "2ba1",
	"./whatsapp.svg": "2201",
	"./yanzhengshenfen_hover.svg": "8ba0",
	"./yuanduigou.svg": "5170",
	"./zeng.svg": "856a",
	"./zhanghuxinxi-hong.svg": "97a8",
	"./zhanghuxinxi-hui.svg": "7e23",
	"./zhe.svg": "16e5",
	"./zhongzhimima.svg": "7b90",
	"./zhongzhimima_hover.svg": "bf72",
	"./zhucechenggong-hong.svg": "670e",
	"./zhucechenggong-hui.svg": "436c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";